import React from 'react';
import { Box, Typography } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

/**
 * AI Assistant — coming soon.
 * The backend endpoint has been deferred to a future release.
 * This placeholder keeps the tab visible in the UI without making any API calls.
 */
export default function AIAssistantView() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 2,
        p: 4,
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      <SmartToyIcon sx={{ fontSize: 48, opacity: 0.4 }} />
      <Typography variant="h6" color="text.secondary">
        AI Assistant — Coming Soon
      </Typography>
      <Typography variant="body2" color="text.secondary">
        We're working on an AI-powered assistant that can answer questions about
        BridgeFirst Forecasting. Check back in a future update.
      </Typography>
    </Box>
  );
}
